import { validateFile } from '@om/validation';
import { AHOC_UPLOAD_DOCUMENTS_CONFIG, setAhocDocumentValid } from '../../../actions/allsureHomeClaim/uploadDocuments';
import { AHOC_MANDATORY_DOCUMENTS } from '../../../actions/allsureHomeClaim/types';

let prevValidationAction = null;
export const uploadDocumentsValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        error =  validateFile(action.value.fileContaint, {
                  minInputSize: AHOC_UPLOAD_DOCUMENTS_CONFIG.MIN_INPUT_SIZE,
                  minInputSizeName: AHOC_UPLOAD_DOCUMENTS_CONFIG.MIN_INPUT_SIZE_NAME,
                  maxInputSize: AHOC_UPLOAD_DOCUMENTS_CONFIG.MAX_INPUT_SIZE,
                  maxInputSizeName: AHOC_UPLOAD_DOCUMENTS_CONFIG.MAX_INPUT_SIZE_NAME,
                  validFileTypes: AHOC_UPLOAD_DOCUMENTS_CONFIG.VALID_UPLOAD_TYPES,
                  required:false
              })
            ;
        if (action.value.inputType) {
            return setAhocDocumentValid(error, action.value.inputType);
        } else {
            return null;
        }
    })();
    if (!validationAction) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
